<script>
import CustomArrow from '@components/custom-arrow'

export default {
  name: 'AccordionButton',
  components: { CustomArrow },
  props: {
    complaintType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      validImg: null,
    }
  },
  created() {
    this.validateImg()
  },
  methods: {
    validateImg() {
      const { srcName } = this.complaintType

      if (srcName)
        this.validImg = this.getImgUrl(`${this.complaintType.srcName}@2x`)

      this.validImg = this.getImgUrl('lifesaver@2x')

      if (this.complaintType.button_action !== 'load-article')
        this.imageFallBack()
    },
    getImgUrl: function(name) {
      var image = require.context('@assets/images/accordion/', false, /\.png$/)
      return image('./' + name + '.png')
    },
    imageFallBack: function() {
      this.validImg = this.getImgUrl('lifesaver@2x')
    },
    imageExists(imageUrl) {
      var http = new XMLHttpRequest()
      http.open('HEAD', imageUrl, false)
      http.send()
      return http.status !== 404
    },
  },
}
</script>

<template>
  <BaseButton
    :class="$style.buttonAccordion"
    v-on="$listeners"
  >
    <div :class="$style.button__content">
      {{ complaintType.title }}
    </div>
    <CustomArrow
      :class="$style.button__icon"
      direction="right"
    />
  </BaseButton>
</template>

<style lang="scss" module scoped>
@import '@design';

.button {
  &Accordion {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 5rem;
    padding: 0.5rem 0.5rem 0 0.3rem;
    font-size: 1rem;
    color: $darker-gray;
    text-align: left;
    background-color: $white;
    border-radius: 0;
    &:not(:last-child) {
      border-bottom: 1px solid $divider-gray;
    }

    &:focus {
      outline: 0;
    }
  }

  &__icon {
    max-width: 1.6rem;
    max-height: 1.6rem;
    margin-top: 0.3rem;
  }

  &__content {
    width: 100%;
    margin-top: -0.2rem;
    font-weight: 500;

    @extend %typography-small;

    img {
      margin-right: 2em;
    }
  }
}
</style>
